const getClientEnv = (): 'dev' | 'staging' | 'prd' => {
	if (typeof window === 'undefined') return 'prd';
	const host = window.location.hostname;
	if (host === 'localhost' || host.includes('dev.teaches.cc')) return 'dev';
	if (host.includes('staging.teaches.cc')) return 'staging';
	return 'prd';
};

const currentEnv = process.env.NEXT_PUBLIC_ENV || getClientEnv();

export const isDev = currentEnv === 'dev';
export const isStaging = currentEnv === 'staging';
// Infrastructure must use the real environment, never the QA feature override.
export const isProductionEnvironment = currentEnv === 'prd';

const getProductionOverride = (): boolean => {
	if ((!isDev && !isStaging) || typeof window === 'undefined') return false;
	try {
		return window.localStorage.getItem('isProduction') === 'true';
	} catch {
		return false;
	}
};

// Read once at startup so all feature gates agree; reload after changing storage.
export const isProd = isProductionEnvironment || getProductionOverride();

export const openAdminLogin = (): void => {
	let url = 'https://teaches.cc/admin/login';
	if (isDev) url = 'https://dev.teaches.cc/admin/login';
	else if (isStaging) url = 'https://staging.teaches.cc/admin/login';
	window.open(url, '_blank');
};

export const isInLineBrowser = (): boolean => {
	if (typeof navigator === 'undefined') return false;
	return /Line\//i.test(navigator.userAgent);
};
